// Generated by GitHub Copilot
import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useAppMode } from '#hooks/use-app-mode.ts'

export const Route = createFileRoute('/_appSettings/$companyId/settings/')({
  component: RouteComponent,
})

function RouteComponent() {
  const params = Route.useParams()
  const appMode = useAppMode()
  // App mode: the layout renders the mobile section list at the settings root, so
  // the index must NOT forward to a panel — render nothing and let the list show.
  // Desktop: keep forwarding to the first panel (the rail + content need a panel).
  if (appMode) return null
  return (
    <Navigate
      to="/$companyId/settings/user"
      params={{ companyId: params.companyId }}
    />
  )
}
